var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CCol',{attrs:{"sm":"6","md":"2"}},[_c('CButton',{staticStyle:{"margin":"0px auto 10px"},attrs:{"block":"","color":"primary"},on:{"click":_vm.generatePDF}},[_vm._v("Print")])],1),_c('CCard',[_c('full-calendar',{attrs:{"config":_vm.config,"events":_vm.events}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }